import React from "react";
import { Search, MessageSquare, BookOpen, Trophy, ArrowRight } from "lucide-react";
import { Link } from "react-router-dom";
import { Badge } from "./ui/badge";
import { Button } from "./ui/button";
import { howItWorks } from "../data/mock";

const iconMap = { Search, MessageSquare, BookOpen, Trophy };

const HowItWorks = () => {
  return (
    <section className="py-24 bg-white">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center max-w-2xl mx-auto mb-16">
          <Badge className="bg-brand-light text-brand hover:bg-brand-light mb-4 border-0">Il tuo percorso</Badge>
          <h2 className="font-display text-4xl md:text-5xl font-bold text-brand-dark mb-4 leading-tight">
            Come <span className="italic text-brand">funziona</span>
          </h2>
          <p className="text-lg text-brand-dark/70">Quattro semplici passi per trasformare la tua passione in una carriera professionale.</p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-6 relative">
          {/* Connecting line for desktop */}
          <div className="hidden lg:block absolute top-16 left-[12.5%] right-[12.5%] h-px bg-gradient-to-r from-transparent via-emerald-200 to-transparent"></div>

          {howItWorks.map((step, i) => {
            const Icon = iconMap[step.icon];
            return (
              <div key={step.step} className="relative bg-[#fafaf7] rounded-3xl p-8 border border-emerald-100 hover:border-brand transition-all hover:-translate-y-1 group">
                <div className="absolute -top-4 -right-4 w-10 h-10 rounded-full bg-white shadow-md border border-emerald-100 flex items-center justify-center font-display font-bold text-brand text-sm">
                  {step.step}
                </div>
                <div className="w-14 h-14 rounded-2xl bg-brand text-white flex items-center justify-center mb-5 group-hover:scale-110 transition-transform">
                  <Icon className="w-7 h-7" strokeWidth={2} />
                </div>
                <h3 className="font-display text-xl font-bold text-brand-dark mb-3">{step.title}</h3>
                <p className="text-sm text-brand-dark/70 leading-relaxed">{step.description}</p>
              </div>
            );
          })}
        </div>

        <div className="mt-12 text-center">
          <Link to="/richiedi-info">
            <Button size="lg" className="bg-brand hover:bg-brand-dark text-white rounded-full h-14 px-8 font-bold">
              Inizia ora <ArrowRight className="w-4 h-4 ml-2" />
            </Button>
          </Link>
        </div>
      </div>
    </section>
  );
};

export default HowItWorks;
